import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Typography, Box } from "@mui/material";
import "./Home.css";

const Home = () => {
    return (
        <Row>
            <Col
                md={6}
                className="d-flex flex-direction-column align-items-center justify-content-center"
            >
                <Box m={4}>
                    <Typography variant="h3">
                        Connect with friends on chatterBoxx
                    </Typography>
                    <Typography mt={4}>
                        <Link to="/login">
                            <Button variant="success">
                                get started
                                <i
                                    style={{ marginLeft: "10px" }}
                                    className="fa fa-commenting"
                                    aria-hidden="true"
                                ></i>
                            </Button>
                        </Link>
                    </Typography>
                </Box>
            </Col>
            <Col md={6} className="home_bg"></Col>
        </Row>
    );
};

export default Home;
